export default function employees(state = [], action) {
    switch (action.type) {
        case "UPDATE_EMPLOYEES":
            return action.data
        default:
            return state
    }
}
